import * as constants from './constants'

// ------------------------------------
// Actions
// ------------------------------------
export const handleView = (reference, location) => ({
  payload: {
    location,
    reference,
  },
  type: constants.HANDLE_VIEW,
})
export const loadSignup = (id, accessKey) => ({
  payload: {
    accessKey,
    id,
  },
  type: constants.LOAD_SIGNUP,
})
export const receiveSignup = signup => ({
  payload: { signups: [signup] },
  type: constants.RECEIVE_SIGNUPS,
})
export const receiveSignups = signups => ({
  payload: { signups },
  type: constants.RECEIVE_SIGNUPS,
})



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/modules/signup/actions.js